import React from "react";
import rotate from "./../images/icons/screen_rotation_black_24dp.svg";

function LandscapeWarning(props) {
  return (
    <div className="landscape-warning w-100 h-100 bg-custom-dark absolute top-0 left-0 flex items-center justify-center z-999 ">
      <div className="custom-light flex">
        <img src={rotate} alt="rotate your device" />
        <p className="ml2">{props.i18n['landscape_warning']}</p>
      </div>
    </div>
  );
}

export default LandscapeWarning;


